import React, { useEffect, useMemo, useState } from 'react';
import Container from '../components/Container';
import TableTitle from '../components/TableTitle';
import Modal from '../components/Modal';
import { Table } from '../components/Table';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useCopyText } from '../hooks';
import { QuickRegistrationForm, useRegisteredUsersStore } from '../features/quickRegistration';

const QuickRegistration = () => {
  const [showModal, setShowModal] = useState(false);
  const { data, isLoading, error, fetchRegisteredUsers } = useRegisteredUsersStore();
  const handleCopy = useCopyText();

  useEffect(() => {
    fetchRegisteredUsers();
  }, []);

  const columns = useMemo(
    () => [
      {
        key: 'fio',
        title: 'ФИО',
        render: (value) => value ?? ' - ',
      },
      {
        key: 'email',
        title: 'Email',
        render: (value) => value ?? ' - ',
      },
      // {
      //   key: 'username',
      //   title: 'Логин',
      // },
      {
        key: 'password',
        title: 'Временный пароль',
      },

      {
        key: 'phone',
        title: 'Телефон',
        render: (value) => <div className={'min-w-max'}>{value ?? ' - '}</div>,
      },
      {
        key: 'created_at',
        title: 'Регистрация',
        render: (value) => new Date(value).toLocaleString('ru-RU'),
      },
      {
        key: 'actions',
        title: 'Действия',
        render: (row) => (
          <button
            className={'flex justify-center align-center w-full'}
            onClick={(e) => handleCopy(`Логин:${row?.username} \r\nПароль:${row?.password}`, 'Логин и пароль скопированы')}>
            <ContentCopyIcon className="hover:text-primary-500 cursor-pointer" />
          </button>
        ),
      },
    ],
    [handleCopy]
  );

  return (
    <Container>
      <TableTitle containerClass={'max-w-7xl mx-auto'} title={'Быстрая регистрация'} loading={isLoading} handlerAddButton={() => setShowModal(true)} />
      <Table columns={columns} data={data} loading={isLoading} error={error} />
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        title="Зарегистрировать пользователя"
        showSave={false}
        error={null}
        classWidth="relative w-11/12 lg:w-1/2 my-6 mx-2">
        <QuickRegistrationForm setShowModal={setShowModal} />
      </Modal>
    </Container>
  );
};
export default QuickRegistration;
